import type { SectionLocale } from '../types'

export const ADMIN_BASE_LOCALE: SectionLocale = [
  [
    'admin_breadcrumbs_orgstructure',
    {
      ru: 'Организационная структура',
      en: 'Org structure',
    },
  ],
  [
    'admin_breadcrumbs_employees',
    {
      ru: 'Сотрудники',
      en: 'Employees',
    },
  ],
  [
    'admin_breadcrumbs_positions',
    {
      ru: 'Должности',
      en: 'Positions',
    },
  ],
  [
    'admin_breadcrumbs_offices',
    {
      ru: 'Офисы',
      en: 'Offices',
    },
  ],
  [
    'admin_breadcrumbs_countries',
    {
      ru: 'Страны',
      en: 'Countries',
    },
  ],
  [
    'admin_breadcrumbs_cities',
    {
      ru: 'Города',
      en: 'Cities',
    },
  ],
  // Employee management translations
  [
    'admin_employees_title',
    {
      ru: 'Сотрудники',
      en: 'Employees',
    },
  ],
  [
    'admin_employees_blocked_status',
    {
      ru: 'Статус блокировки',
      en: 'Blocked status',
    },
  ],
  [
    'admin_employees_blocked_status_blocked',
    {
      ru: 'Заблокирован',
      en: 'Blocked',
    },
  ],
  [
    'admin_employees_blocked_status_not_blocked',
    {
      ru: 'Не заблокирован',
      en: 'Not blocked',
    },
  ],
  [
    'admin_employees_add_employee',
    {
      ru: 'Добавить сотрудника',
      en: 'Add employee',
    },
  ],
  [
    'admin_employees_search_placeholder',
    {
      ru: 'Поиск по имени',
      en: 'Search by name',
    },
  ],
  [
    'admin_employees_department',
    {
      ru: 'Департамент',
      en: 'Department',
    },
  ],
  [
    'admin_employees_department_unassigned',
    {
      ru: 'Без департамента',
      en: 'Unassigned',
    },
  ],
  [
    'admin_employees_reset_filters',
    {
      ru: 'Сбросить фильтры',
      en: 'Reset filters',
    },
  ],
  [
    'admin_employees_table_employee',
    {
      ru: 'Сотрудник',
      en: 'Employee',
    },
  ],
  [
    'admin_employees_table_position',
    {
      ru: 'Должность',
      en: 'Position',
    },
  ],
  [
    'admin_employees_table_department',
    {
      ru: 'Департамент',
      en: 'Department',
    },
  ],
  [
    'admin_employees_table_role',
    {
      ru: 'Роль',
      en: 'Role',
    },
  ],
  [
    'admin_employees_table_actions',
    {
      ru: 'Действия',
      en: 'Actions',
    },
  ],
  [
    'admin_employee_unblock_user',
    {
      ru: 'Разблокировать пользователя',
      en: 'Unblock user',
    },
  ],
  [
    'admin_employee_archive_user',
    {
      ru: 'Заблокировать пользователя',
      en: 'Block user',
    },
  ],
  [
    'admin_employee_archive_user_modal_title',
    {
      ru: 'Заблокировать профиль?',
      en: 'Block profile?',
    },
  ],
  [
    'admin_employee_archive_user_modal_button',
    {
      ru: 'Заблокировать',
      en: 'Block',
    },
  ],
  [
    'admin_employee_archive_user_modal_cancel_button',
    {
      ru: 'Отмена',
      en: 'Cancel',
    },
  ],
  [
    'admin_employee_archive_user_modal_description',
    {
      ru: 'Пользователь будет удален из списка активных',
      en: 'User will be removed from the active list',
    },
  ],
  [
    'admin_employee_unarchive_user_modal_title',
    {
      ru: 'Разблокировать профиль?',
      en: 'Unblock profile?',
    },
  ],
  [
    'admin_employee_unarchive_user_modal_button',
    {
      ru: 'Разблокировать',
      en: 'Unblock',
    },
  ],
  [
    'admin_employee_unarchive_user_modal_cancel_button',
    {
      ru: 'Отмена',
      en: 'Cancel',
    },
  ],
  [
    'admin_employee_unarchive_user_modal_description',
    {
      ru: 'Пользователь будет возвращен в список активных',
      en: 'The user will be returned to the active list',
    },
  ],
  [
    'admin_employee_office',
    {
      ru: 'Офис',
      en: 'Office',
    },
  ],
  [
    'admin_employee_chief',
    {
      ru: 'Руководитель',
      en: 'Chief',
    },
  ],
  [
    'admin_employee_role',
    {
      ru: 'Роль',
      en: 'Role',
    },
  ],
  [
    'admin_employee_birthday',
    {
      ru: 'Дата рождения',
      en: 'Birthday',
    },
  ],
  [
    'admin_employee_email',
    {
      ru: 'Email',
      en: 'Email',
    },
  ],
  [
    'admin_employee_phone',
    {
      ru: 'Телефон',
      en: 'Phone',
    },
  ],
  [
    'admin_employee_telegram',
    {
      ru: 'Telegram',
      en: 'Telegram',
    },
  ],
  [
    'admin_employee_reddy',
    {
      ru: 'Reddy',
      en: 'Reddy',
    },
  ],
  [
    'admin_employee_join_date',
    {
      ru: 'Дата присоединения',
      en: 'Join date',
    },
  ],
  [
    'admin_employee_head_of_department',
    {
      ru: 'Руководитель департамента',
      en: 'Head of department',
    },
  ],
  [
    'admin_employee_first_name',
    {
      ru: 'Имя',
      en: 'First name',
    },
  ],
  [
    'admin_employee_last_name',
    {
      ru: 'Фамилия',
      en: 'Last name',
    },
  ],
  [
    'admin_employee_birthday',
    {
      ru: 'Дата рождения',
      en: 'Birthday',
    },
  ],
  [
    'admin_employee_department',
    {
      ru: 'Департамент',
      en: 'Department',
    },
  ],
  [
    'admin_employee_position',
    {
      ru: 'Должность',
      en: 'Position',
    },
  ],
  [
    'admin_employee_is_probation_passed',
    {
      ru: 'Испытательный срок пройден',
      en: 'Probation passed',
    },
  ],
  [
    'admin_employee_edit_profile',
    {
      ru: 'Редактировать профиль',
      en: 'Edit profile',
    },
  ],
  [
    'admin_employee_additional_phone',
    {
      ru: 'Дополнительный телефон',
      en: 'Additional phone',
    },
  ],
  [
    'admin_employee_save_changes',
    {
      ru: 'Сохранить изменения',
      en: 'Save changes',
    },
  ],
  [
    'admin_employee_new_employee',
    {
      ru: 'Новый сотрудник',
      en: 'New employee',
    },
  ],
  [
    'admin_employee_successfully_created',
    {
      ru: 'Сотрудник успешно создан',
      en: 'Employee successfully created',
    },
  ],
  [
    'admin_employee_blocked',
    {
      ru: 'Заблокирован',
      en: 'Blocked',
    },
  ],
  [
    'admin_employee_successfully_updated',
    {
      ru: 'Профиль сотрудника успешно обновлен',
      en: 'Employee profile successfully updated',
    },
  ],
  // Position management translations
  [
    'admin_positions_title',
    {
      ru: 'Должности',
      en: 'Positions',
    },
  ],
  [
    'admin_positions_add_position',
    {
      ru: 'Добавить должность',
      en: 'Add position',
    },
  ],
  [
    'admin_positions_search_placeholder',
    {
      ru: 'Поиск по названию',
      en: 'Search by name',
    },
  ],
  [
    'admin_positions_no_data_available',
    {
      ru: 'Нет доступных должностей',
      en: 'No positions available',
    },
  ],
  [
    'admin_positions_table_name',
    {
      ru: 'Название',
      en: 'Name',
    },
  ],
  [
    'admin_positions_table_users',
    {
      ru: 'Пользователи',
      en: 'Users',
    },
  ],
  [
    'admin_positions_table_actions',
    {
      ru: 'Действия',
      en: 'Actions',
    },
  ],
  [
    'admin_positions_edit_title',
    {
      ru: 'Редактировать должность',
      en: 'Edit Position',
    },
  ],
  [
    'admin_positions_new_title',
    {
      ru: 'Новая должность',
      en: 'New Position',
    },
  ],
  [
    'admin_positions_name_label',
    {
      ru: 'Название',
      en: 'Name',
    },
  ],
  [
    'admin_positions_name_required',
    {
      ru: 'Поле обязательно для заполнения',
      en: 'Required field',
    },
  ],
  [
    'admin_positions_save_changes',
    {
      ru: 'Сохранить изменения',
      en: 'Save changes',
    },
  ],
  [
    'admin_positions_successfully_created',
    {
      ru: 'Должность успешно создана',
      en: 'Position successfully created',
    },
  ],
  [
    'admin_positions_successfully_updated',
    {
      ru: 'Должность успешно обновлена',
      en: 'Position successfully updated',
    },
  ],
  // Office management translations
  [
    'admin_offices_title',
    {
      ru: 'Офисы',
      en: 'Offices',
    },
  ],
  [
    'admin_offices_add_office',
    {
      ru: 'Добавить офис',
      en: 'Add office',
    },
  ],
  [
    'admin_offices_no_data_available',
    {
      ru: 'Нет доступных офисов',
      en: 'No offices available',
    },
  ],
  [
    'admin_countries_search_placeholder',
    {
      ru: 'Поиск по названию страны',
      en: 'Search by name',
    },
  ],
  [
    'admin_cities_search_placeholder',
    {
      ru: 'Поиск по названию города',
      en: 'Search by name',
    },
  ],
  [
    'admin_offices_table_name',
    {
      ru: 'Название',
      en: 'Name',
    },
  ],
  [
    'admin_offices_table_actions',
    {
      ru: 'Действия',
      en: 'Actions',
    },
  ],
  [
    'admin_offices_edit_title',
    {
      ru: 'Редактировать офис',
      en: 'Edit Office',
    },
  ],
  [
    'admin_offices_new_title',
    {
      ru: 'Новый офис',
      en: 'New Office',
    },
  ],
  [
    'admin_offices_name_label',
    {
      ru: 'Название офиса',
      en: 'Office name',
    },
  ],
  [
    'admin_offices_address_label',
    {
      ru: 'Адрес',
      en: 'Address',
    },
  ],
  [
    'admin_offices_city_label',
    {
      ru: 'Город',
      en: 'City',
    },
  ],
  [
    'admin_offices_office_manager_label',
    {
      ru: 'Менеджер офиса',
      en: 'Office manager',
    },
  ],
  [
    'admin_offices_search_placeholder',
    {
      ru: 'Поиск по названию офиса',
      en: 'Search by office name',
    },
  ],
  [
    'admin_offices_save_changes',
    {
      ru: 'Сохранить изменения',
      en: 'Save changes',
    },
  ],
  [
    'admin_offices_successfully_created',
    {
      ru: 'Офис успешно создан',
      en: 'Office successfully created',
    },
  ],
  [
    'admin_offices_successfully_updated',
    {
      ru: 'Офис успешно обновлен',
      en: 'Office successfully updated',
    },
  ],
  // Cities management translations
  [
    'admin_cities_title',
    {
      ru: 'Города',
      en: 'Cities',
    },
  ],
  [
    'admin_cities_add_city',
    {
      ru: 'Добавить город',
      en: 'Add city',
    },
  ],
  [
    'admin_cities_no_data_available',
    {
      ru: 'Нет доступных городов',
      en: 'No cities available',
    },
  ],
  [
    'admin_cities_table_city',
    {
      ru: 'Город',
      en: 'City',
    },
  ],
  [
    'admin_cities_table_actions',
    {
      ru: 'Действия',
      en: 'Actions',
    },
  ],
  [
    'admin_cities_edit_title',
    {
      ru: 'Редактировать город',
      en: 'Edit City',
    },
  ],
  [
    'admin_cities_new_title',
    {
      ru: 'Новый город',
      en: 'New City',
    },
  ],
  [
    'admin_cities_name_label',
    {
      ru: 'Название города',
      en: 'City name',
    },
  ],
  [
    'admin_cities_country_label',
    {
      ru: 'Страна',
      en: 'Country',
    },
  ],
  [
    'admin_cities_save_changes',
    {
      ru: 'Сохранить изменения',
      en: 'Save changes',
    },
  ],
  [
    'admin_cities_successfully_created',
    {
      ru: 'Город успешно создан',
      en: 'City successfully created',
    },
  ],
  [
    'admin_cities_successfully_updated',
    {
      ru: 'Город успешно обновлен',
      en: 'City successfully updated',
    },
  ],
  // Countries management translations
  [
    'admin_countries_title',
    {
      ru: 'Страны',
      en: 'Countries',
    },
  ],
  [
    'admin_countries_add_country',
    {
      ru: 'Добавить страну',
      en: 'Add country',
    },
  ],
  [
    'admin_countries_no_data_available',
    {
      ru: 'Нет доступных стран',
      en: 'No countries available',
    },
  ],
  [
    'admin_countries_table_name',
    {
      ru: 'Название',
      en: 'Name',
    },
  ],
  [
    'admin_countries_table_actions',
    {
      ru: 'Действия',
      en: 'Actions',
    },
  ],
  [
    'admin_countries_edit_title',
    {
      ru: 'Редактировать страну',
      en: 'Edit Country',
    },
  ],
  [
    'admin_countries_new_title',
    {
      ru: 'Новая страна',
      en: 'New Country',
    },
  ],
  [
    'admin_countries_name_label',
    {
      ru: 'Название страны',
      en: 'Country name',
    },
  ],
  [
    'admin_countries_save_changes',
    {
      ru: 'Сохранить изменения',
      en: 'Save changes',
    },
  ],
  [
    'admin_countries_successfully_created',
    {
      ru: 'Страна успешно создана',
      en: 'Country successfully created',
    },
  ],
  [
    'admin_countries_successfully_updated',
    {
      ru: 'Страна успешно обновлена',
      en: 'Country successfully updated',
    },
  ],
  // Error messages
  [
    'admin_cities_error_create',
    {
      ru: 'Не удалось создать город',
      en: 'Failed to create city',
    },
  ],
  [
    'admin_cities_error_update',
    {
      ru: 'Не удалось обновить город',
      en: 'Failed to update city',
    },
  ],
  [
    'admin_countries_error_create',
    {
      ru: 'Не удалось создать страну',
      en: 'Failed to create country',
    },
  ],
  [
    'admin_countries_error_update',
    {
      ru: 'Не удалось обновить страну',
      en: 'Failed to update country',
    },
  ],
]
